export const arrayBufferFromBlob = (file: Blob): Promise<ArrayBuffer> => {
  return new Promise<ArrayBuffer>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result;

      if (result instanceof ArrayBuffer) {
        resolve(result);

        return;
      }

      reject(new Error('Failed to read blob as ArrayBuffer'));
    };
    reader.onerror = () => {
      reject(reader.error ?? new Error('Failed to read blob as ArrayBuffer'));
    };
    reader.readAsArrayBuffer(file);
  });
};
